import Vue from 'vue'
import hint from './hint.js'

Vue.directive('hint', hint)
